import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/shopLabPhoto/banner.jpg'
import navColor from '../../assets/shopLabPhoto/nav/color.jpg'

import far1 from '../../assets/shopLabPhoto/nav/far1.png'
import far1_active from '../../assets/shopLabPhoto/nav/far1_active.png'
import far2 from '../../assets/shopLabPhoto/nav/far2.png'
import far2_active from '../../assets/shopLabPhoto/nav/far2_active.png'
import far3 from '../../assets/shopLabPhoto/nav/far3.png'
import far3_active from '../../assets/shopLabPhoto/nav/far3_active.png'
import far4 from '../../assets/shopLabPhoto/nav/far4.png'
import far4_active from '../../assets/shopLabPhoto/nav/far4_active.png'
import far5 from '../../assets/shopLabPhoto/nav/far5.png'
import far5_active from '../../assets/shopLabPhoto/nav/far5_active.png'


import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(125),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(125),
    backgroundImage: 'none',
  },
  navCtnFixed: {
    height: calcRemFn(125),
    backgroundImage: 'none',
  },
  topBtnLayout: {
    alignItems: 'center',
  },
  topBtnBaseCss: {
    // width: calcRemFn(187.5),
    height: calcRemFn(42)
  },
  bottomBtnLayout: {
    justifyContent: 'center',
  },
  bottomBtnBaseCss: {
    width: calcRemFn(107.5),
    height: calcRemFn(41)
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    },
    {
      key: 'top4',
      show: true,
      img: far4,
      img_actived: far4_active,
    },
    {
      key: 'top5',
      show: true,
      img: far5,
      img_actived: far5_active,
    }
  ]
}

const level1_length = navData.top.length
let leve2_content = {}
let start = 0

Array(level1_length).fill(0).map( (item, index1) => {
  let num = index1 > 3 ? 2 : 3

  leve2_content[`top${index1+1}`] = Array(num).fill(0).map( (item, index2) => {
    return {
      key: `_i${index2+1}`,
      show: true,
      img: require(`../../assets/shopLabPhoto/nav/son${start + index2 + 1}.png`),
      img_actived: require(`../../assets/shopLabPhoto/nav/son${start + index2 + 1}_active.png`)
    }
  })

  start += num

})

navData.bottom = leve2_content

const pictureList = [
  {
    key: '1_1',
    pid: 102865
  },
  {
    key: '1_2',
    pid: 102865,
  },
  {
    key: '1_3',
    pid: 102865,
  },
  {
    key: '2_1',
    pid: 102866,
    picNum: 3
  },
  {
    key: '2_2',
    pid: 102866
  },
  {
    key: '2_3',
    pid: 102866
  },
  {
    key: '3_1',
    pid: 102868
  },
  {
    key: '3_2',
    pid: 102868,
    picNum: 3
  },
  {
    key: '3_3',
    pid: 102868
  },
  {
    key: '4_1',
    pid: 102867
  },
  {
    key: '4_2',
    pid: 102867
  },
  {
    key: '4_3',
    pid: 102867
  },
  {
    key: '5_1',
    pid: 102869
  },
  {
    key: '5_2',
    pid: 102869
  },
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/shopLabPhoto/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

const topDiff = {
  firstSon: '_i1',
  top1_i1: 155,
  top2_i1: 90,
  top3_i1: 65,
  top4_i1: 50,
  top5_i1: 63,
}

export default {
  title: '写真照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
